import { render } from "./SectionNav.vue?vue&type=template&id=60aba80a&scoped=true"
import script from "./SectionNav.vue?vue&type=script&lang=js"
export * from "./SectionNav.vue?vue&type=script&lang=js"

import "./SectionNav.vue?vue&type=style&index=0&id=60aba80a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aba80a"]])

export default __exports__